import { createFileRoute } from '@tanstack/react-router';

import { validateRouteRole } from '@/lib/routing.js';
import { coachCalendarSearchSchema } from '@/lib/my-classes-utils.js';
import { isCoach } from '@airreading/common';

import { CoachClassesCalendar } from './-components/coach-classes-calendar.js';

export const Route = createFileRoute('/_layout/my-classes/calendar')({
  beforeLoad: validateRouteRole(isCoach),
  component: MyClassesCalendar,
  validateSearch: coachCalendarSearchSchema,
});

function MyClassesCalendar() {
  return <CoachClassesCalendar route={Route} />;
}
